// extracted by mini-css-extract-plugin
module.exports = {"container":"icon-feature-module--container--3byIc","title":"icon-feature-module--title--12IpT","description":"icon-feature-module--description--3LxE9"};